"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invokeAttestationPopUp = exports.updateSubscription = exports.getPreferences = exports.removeFromCollection = exports.addToCollection = exports.getFavoriteFundsCollectionData = exports.invokeLoginModal = undefined;

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _fund_utility = require("../../../packages/common-utilities/src/fund_utility");

var _ramda = require("ramda");

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global fundsMarketingConfiguration*/
var FundsMarketingAEMService = {
  invokeLoginModal: function invokeLoginModal() {
    fundsMarketingConfiguration.invokeLoginModalCallbackfn();
  },
  invokeExtLinkConfirmWindow: function invokeExtLinkConfirmWindow(url) {
    fundsMarketingConfiguration.invokeExtLinkConfirmWindow(url);
  },
  isExternalSite: function isExternalSite(url) {
    var isExternal = false;
    if (!(0, _ramda.isNil)(fundsMarketingConfiguration) && !(0, _functional_utility.isNilOrEmpty)(fundsMarketingConfiguration.whitelistedDomains) && fundsMarketingConfiguration.invokeExtLinkConfirmWindow) {
      isExternal = !(0, _ramda.includes)(_string_utility2.default.getHostnameFromRegex(url), fundsMarketingConfiguration.whitelistedDomains);
    }
    return isExternal;
  },
  getFavoriteFundsCollectionData: function getFavoriteFundsCollectionData() {
    return fundsMarketingConfiguration.invokeGetCollection().then(function (response) {
      if (!(0, _functional_utility.isNilOrEmpty)(response) && response.status === 200) {
        return (0, _fund_utility.getFavoriteFunds)(response.data);
      }
      return [];
    });
  },
  addToCollection: function addToCollection(identifier) {
    return fundsMarketingConfiguration.invokeAddToCollection("Product", identifier).then(function (response) {
      if (!(0, _functional_utility.isNilOrEmpty)(response) && response.status === 200) {
        return (0, _fund_utility.getFavoriteFunds)(response.data);
      }
    });
  },
  removeFromCollection: function removeFromCollection(identifier) {
    return fundsMarketingConfiguration.invokeRemoveFromCollection("Product", identifier).then(function (response) {
      if (!(0, _functional_utility.isNilOrEmpty)(response) && response.status === 200) {
        return (0, _fund_utility.getFavoriteFunds)(response.data);
      }
    });
  },
  getPreferences: function getPreferences() {
    return fundsMarketingConfiguration.invokeGetPreference().then(function (response) {
      if (!(0, _functional_utility.isNilOrEmpty)(response) && response.status === 200) {
        if ((0, _ramda.isNil)(response.data.preferences.fund_subscription_flag) || response.data.preferences.fund_subscription_flag !== "Y") {
          return { isSubscribed: false, frequency: null };
        }
        return { isSubscribed: true, frequency: response.data.preferences.fund_subscription_frequency };
      }
    });
  },
  updateSubscription: function updateSubscription(preferenceName, preferenceValue) {
    return fundsMarketingConfiguration.invokeUpdatePreference(preferenceName, preferenceValue).then(function (response) {
      if (!(0, _functional_utility.isNilOrEmpty)(response)) {
        return response.status === 200;
      }
    });
  },
  invokeAttestationPopUp: function invokeAttestationPopUp(disclosure) {
    if (!(0, _ramda.isNil)(fundsMarketingConfiguration.invokeAttestationPopUp)) {
      fundsMarketingConfiguration.invokeAttestationPopUp(disclosure);
    }
  }
};

exports.default = FundsMarketingAEMService;
var invokeLoginModal = FundsMarketingAEMService.invokeLoginModal,
    getFavoriteFundsCollectionData = FundsMarketingAEMService.getFavoriteFundsCollectionData,
    addToCollection = FundsMarketingAEMService.addToCollection,
    removeFromCollection = FundsMarketingAEMService.removeFromCollection,
    getPreferences = FundsMarketingAEMService.getPreferences,
    updateSubscription = FundsMarketingAEMService.updateSubscription,
    invokeAttestationPopUp = FundsMarketingAEMService.invokeAttestationPopUp;
exports.invokeLoginModal = invokeLoginModal;
exports.getFavoriteFundsCollectionData = getFavoriteFundsCollectionData;
exports.addToCollection = addToCollection;
exports.removeFromCollection = removeFromCollection;
exports.getPreferences = getPreferences;
exports.updateSubscription = updateSubscription;
exports.invokeAttestationPopUp = invokeAttestationPopUp;